import { error, json } from "@sveltejs/kit";
import { promises } from "fs";
import path from "path";
import { W as WORKSPACE_DIR } from "../../../../../chunks/workspace.js";
function validatePath(requestPath) {
  const normalized = path.normalize(path.join(WORKSPACE_DIR, requestPath));
  if (!normalized.startsWith(WORKSPACE_DIR)) {
    throw error(403, "Access denied: Path outside workspace directory");
  }
  return normalized;
}
const DELETE = async ({ request }) => {
  try {
    const { path: filePath } = await request.json();
    if (!filePath) {
      throw error(400, "Path is required");
    }
    const fullPath = validatePath(filePath);
    const stats = await promises.stat(fullPath);
    if (stats.isDirectory()) {
      await promises.rmdir(fullPath, { recursive: true });
    } else {
      await promises.unlink(fullPath);
    }
    return json({
      success: true,
      message: "File deleted successfully",
      path: filePath
    });
  } catch (err) {
    if (err instanceof Response) throw err;
    if (err.code === "ENOENT") {
      throw error(404, "File not found");
    }
    console.error("Error deleting file:", err);
    throw error(500, "Failed to delete file");
  }
};
export {
  DELETE
};
